import { Component } from '@angular/core';

@Component({
  selector: 'lib-ds-colorbar',
  templateUrl: './colorbar.component.html',
  styleUrls: ['./colorbar.component.scss']
})
export class DsColorbarComponent {}

